import { render, staticRenderFns } from "./UserRole1.vue?vue&type=template&id=15949232&scoped=true"
import script from "./UserRole1.vue?vue&type=script&lang=js"
export * from "./UserRole1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15949232",
  null
  
)

export default component.exports